import globalSpacing from '../../../Theme/Spacing';

const styles = {
  // container: {
  //   flexDirection: 'column',
  //   display: 'flex',
  // },
  paper: {
    marginTop: globalSpacing.sm,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto',
    // border: '1px solid black',
    maxHeight: 'calc(75vh - 150px)',
    '&::-webkit-scrollbar': {
      width: '0.3rem',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: 'lightgrey',
      borderRadius: 15,
    },
  },
  gridConatiner: {
    display: 'grid',
    gridTemplateColumns: 'repeat(4, 1fr)' /* Creates 5 equal columns */,
    maxHeight: '100%',
    gap: '7px' /* Add spacing between grid items */,
    // justifyItems: 'center' /* Centers the grid items horizontally */,
    alignItems: 'center' /* Centers the grid items vertically */,
    '@media (max-width:1300px)': {
      gridTemplateColumns: 'repeat(3, 1fr)',
    },
  },
  gridItem: {
    // border: '1px solid #ccc',
    padding: '5px 10px',
    textAlign: 'center',
    display: 'flex',
    height: '65px',
  },
};

export default styles;
